<template>
  <v-col cols="12" md="3" sm="12">
    <v-card :loading="loading" class="cor-ou-raca-card mx-auto" height="180">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="pb-0">
        <div class="text-h6 font-weight-black">Cor/Raça</div>
      </v-card-text>

      <div class="cor-ou-raca-card__conteudo">
        <div class="cor-ou-raca-card__grafico">
          <apexchart
            type="donut"
            height="100%"
            width="100%"
            :options="chartOptions"
            :series="series"
          />
        </div>

        <div class="cor-ou-raca-card__legenda">
          <div
            v-for="(label, index) in chartOptions.labels"
            :key="index"
            class="cor-ou-raca-card__item"
          >
            <span
              class="cor-ou-raca-card__cor"
              :style="{ backgroundColor: pegarCor(index) }"
            ></span>
            <span class="cor-ou-raca-card__texto">{{ label }}: {{ series[index] }}</span>
          </div>
        </div>
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "CorOuRacaCard",

  props: {
    franquiaId: {
      type: Number,
      default: null,
    },
  },

  watch: {
    franquiaId: {
      handler(value) {
        this.getCoresOuRacas(value);
      },
      immediate: true,
    },
  },

  data() {
    return {
      loading: true,
      series: [],
      colors: [
        "#008FFB",
        "#00E396",
        "#FEB019",
        "#775DD0",
        "#FF4560",
        "#546E7A",
        "#26a69a",
        "#D10CE8",
      ],
      chartOptions: {
        chart: {
          type: "donut",
          sparkline: {
            enabled: true,
          },
        },
        colors: [],
        dataLabels: {
          enabled: false,
        },
        labels: [],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: "60%",
            },
          },
        },
        tooltip: {
          fixed: {
            enabled: false,
          },
          y: {
            formatter: (valor) => `${valor} aluno(s)`,
          },
        },
      },
    };
  },

  methods: {
    pegarCor(index) {
      return this.colors[index % this.colors.length];
    },

    async getCoresOuRacas(franquiaId) {
      this.loading = true;

      try {
        const response = await this.$services.alunosService.coresOuRacas(franquiaId);
        const coresOuRacas = response.data || [];

        this.series = coresOuRacas.map((corOuRaca) => parseInt(corOuRaca.quantidade, 10));
        this.chartOptions = {
          ...this.chartOptions,
          colors: coresOuRacas.map((corOuRaca, index) => this.pegarCor(index)),
          labels: coresOuRacas.map((corOuRaca) => corOuRaca.cor_ou_raca),
        };
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.cor-ou-raca-card {
  overflow: hidden;
}

.cor-ou-raca-card__conteudo {
  display: flex;
  height: 124px;
  padding: 4px 16px 8px;
}

.cor-ou-raca-card__grafico {
  flex: 0 0 40%;
  min-width: 0;
  position: relative;
}

.cor-ou-raca-card__legenda {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding-left: 12px;
}

.cor-ou-raca-card__item {
  align-items: center;
  display: flex;
  margin-bottom: 4px;
}

.cor-ou-raca-card__cor {
  border-radius: 3px;
  display: inline-block;
  flex: 0 0 auto;
  height: 10px;
  margin-right: 6px;
  width: 10px;
}

.cor-ou-raca-card__texto {
  font-size: 0.75rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
